import React, { useState, useEffect, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';

import closeIcon from '../../assets/images/closeIcon.svg';
import classes from './styles.module.scss';

const OPERATION_MESSAGES = {
  preparing: 'Preparing...',
  'copying-from-library': 'Copying from library...',
  'copying-and-trimming': 'Copying and trimming...',
  'uploading-video': 'Uploading video...',
  'uploading-audio': 'Uploading audio...',
  'uploading-image': 'Uploading image...',
  'uploading-document': 'Uploading document...',
  'creating-question': 'Creating question...',
  'creating-text': 'Creating text section...',
  'creating-assigned-section': 'Creating assigned section...',
  'creating-section': 'Creating section...',
  remuxing: 'Processing video...',
  finalizing: 'Finalizing...',
  processing: 'Processing...',
};

export default function SaveProgressModal({
  show,
  handleClose,
  progress,
  sectionIndex,
  totalSections,
  operation,
}) {
  const [displayProgress, setDisplayProgress] = useState(progress);
  const animationFrameRef = useRef(null);
  const currentProgressRef = useRef(progress);

  // Get operation message
  const operationMessage = OPERATION_MESSAGES[operation] || OPERATION_MESSAGES.processing;

  // Get section counter text
  const sectionCounterText =
    totalSections > 0 && sectionIndex > 0
      ? `Section ${sectionIndex} of ${totalSections}`
      : '';

  useEffect(() => {
    // Keep the ref updated with the latest displayed progress
    currentProgressRef.current = displayProgress;
  }, [displayProgress]);

  useEffect(() => {
    // Animate the progress smoothly when progress prop changes
    function animate() {
      const diff = progress - currentProgressRef.current;
      if (Math.abs(diff) < 0.1) {
        setDisplayProgress(progress);
        currentProgressRef.current = progress;
      } else {
        const newVal = currentProgressRef.current + diff * 0.1;
        setDisplayProgress(newVal);
        currentProgressRef.current = newVal;
        animationFrameRef.current = requestAnimationFrame(animate);
      }
    }

    animationFrameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameRef.current);
  }, [progress]);

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.SaveProgressModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      onHide={handleClose}
    >
      <i className={classes.closeIcon} onClick={handleClose}>
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.content}>
        <h3>Saving Draft</h3>
        {sectionCounterText && <p className={classes.sectionCounter}>{sectionCounterText}</p>}
        <p className={classes.operation}>{operationMessage}</p>
        <div className={classes.progressContainer}>
          <div className={classes.progressBackground}>
            <div
              className={classes.progressBar}
              style={{ width: `${displayProgress}%` }}
            />
          </div>
          <span className={classes.percentage}>
            {Math.round(displayProgress)}%
          </span>
        </div>
      </div>
    </Modal>
  );
}

